import React from 'react';
import { componentService } from 'js/services/component.service';

export const Balance = React.lazy(() => import(/* webpackChunkName: "user-balance" */ './Balance'));

/*
<hub2-balance-calc args="WITHDRAWABLE_BALANCE+TOTAL_BONUS_BALANCE"></hub2-balance-calc>
<hub2-bonus-balance></hub2-bonus-balance>
<hub2-bonus-pending-winnings></hub2-bonus-pending-winnings>
<hub2-casino-gaming-balance></hub2-casino-gaming-balance>
<hub2-real-gaming-balance></hub2-real-gaming-balance>
<hub2-ringfenced-real-balance></hub2-ringfenced-real-balance>
<hub2-total-bonus-balance></hub2-total-bonus-balance>
<hub2-total-free-spins-balance></hub2-total-free-spins-balance>
<hub2-withdrawable-balance></hub2-withdrawable-balance>
*/
componentService.registerWebContentComponents({
    Balance,
    BalanceCalc: ({ args }: { args: string }) => <Balance type="balance_calc" args={args}/>,
    BonusBalance: () => <Balance type="bonus_balance"/>,
    BonusPendingWinnings: () => <Balance type="bonus_pending_winnings"/>,
    CasinoGamingBalance: () => <Balance type="casino_gaming_balance"/>,
    RealGamingBalance: () => <Balance type="real_gaming_balance"/>,
    RingfencedRealBalance: () => <Balance type="ringfenced_real_balance"/>,
    TotalBonusBalance: () => <Balance type="total_bonus_balance"/>,
    TotalFreeSpinsBalance: () => <Balance type="free_spin_balance"/>,
    // TODO uncomment after removing deprecated BB replacer TOTAL_GOLDEN_CHIPS_BALANCE 'replacers/total-goldenchips-balance/total-goldenchips-balance.view'
    // TotalGoldenChipsBalance: () => <Balance type="golden_chips_balance"/>,
    WithdrawableBalance: () => <Balance type="withdrawable_balance"/>
});
